import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class GraphsDataServiceProvider {
	constructor(public http: HttpClient) {}

	getLeadsGraphInfo(dateRange): Observable<Object> {
		const url = '/api/user/v1/lead/statistic/created';
		return this.http.post(url, dateRange);
	}

	getShootsGraphInfo(dateRange): Observable<Object> {
		const url = '/api/user/v1/shoot/statistic/due';
		return this.http.post(url, dateRange);
	}

	getPaymentsGraphInfo(dateRange): Observable<Object> {
		const url = '/api/user/v1/payment/amount/statistic/received';
		return this.http.post(url, dateRange);
	}

	getPaymentsDueGraphInfo(data, filter?): Observable<Object> {
		if (filter) {
			data.filterBy = filter;
		}
		const url = '/api/user/v1/payment/amount/statistic/due';
		return this.http.post(url, data);
	}

	getAcceptedLeadGraphInfo(dateRange): Observable<Object> {
		const url = '/api/user/v1/lead/statistic/accepted';
		return this.http.post(url, dateRange);
	}

	getAllTimeStatisticsGraphInfo(filters): Observable<Object> {
		const url = '/api/user/v1/payment/amount/statistic/all-time';
		return this.http.post(url, { jobTypeId: filters.jobTypeId });
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/dashboard/graphs-block/graphs.data.service.ts